module.exports = __webpack_public_path__ + "img/toucharcade_review2.c1967603.png";